.table th:nth-child(2){width:110px;text-align:right}.table th:nth-child(3){width:130px;text-align:right}.top-list-title{margin:0}
/*# sourceMappingURL=top-list.component-27ZPBJDS.css.map */
